import apiSlice from '../../services/api/slice'
import { TAGS } from '../../constants/tags'

const campaignsSlice = apiSlice.injectEndpoints({
  name: 'campaigns',
  endpoints: (builder) => ({
    getCampaigns: builder.query({
      query: () => ({ url: `/v1/admin/campaigns`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.CAMPAIGNS],
    }),
    getCampaign: builder.query({
      query: (campaignId) => ({
        url: `/v1/admin/campaigns/${campaignId}`,
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.CAMPAIGN],
    }),
    getCampaignsForClient: builder.query({
      query: (clientId) => ({
        url: `/v1/admin/campaigns`,
        params: { clientId },
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.CAMPAIGNS],
    }),
    addCampaign: builder.mutation({
      query: (campaign) => ({
        url: `/v1/admin/campaigns`,
        method: 'POST',
        body: campaign,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS],
    }),
    updateCampaign: builder.mutation({
      query: (campaign) => ({
        url: `/v1/admin/campaigns/${campaign.id}`,
        method: 'PUT',
        body: campaign,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    deleteCampaign: builder.mutation({
      query: (campaignId) => ({
        url: `/v1/admin/campaigns/${campaignId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    addProducerToCampaign: builder.mutation({
      query: ({ campaignId, producerId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/producers/${producerId}`,
        method: 'POST',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    removeProducerFromCampaign: builder.mutation({
      query: ({ campaignId, producerId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/producers/${producerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    addRepresentativeToCampaign: builder.mutation({
      query: ({ campaignId, userId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/representatives/${userId}`,
        method: 'POST',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    removeRepresentativeFromCampaign: builder.mutation({
      query: ({ campaignId, userId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/representatives/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    addSectionToLayout: builder.mutation({
      query: ({ campaignId, section }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections`,
        method: 'POST',
        body: section,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    updateSectionInLayout: builder.mutation({
      query: ({ campaignId, sectionId, section }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections/${sectionId}`,
        method: 'PUT',
        body: section,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    deleteSectionFromLayout: builder.mutation({
      query: ({ campaignId, sectionId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections/${sectionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    addFieldToSection: builder.mutation({
      query: ({ campaignId, sectionId, field }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections/${sectionId}/fields`,
        method: 'POST',
        body: field,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    updateFieldInSection: builder.mutation({
      query: ({ campaignId, sectionId, fieldId, field }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections/${sectionId}/fields/${fieldId}`,
        method: 'PUT',
        body: field,
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
    deleteFieldFromSection: builder.mutation({
      query: ({ campaignId, sectionId, fieldId }) => ({
        url: `/v1/admin/campaigns/${campaignId}/sections/${sectionId}/fields/${fieldId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.CAMPAIGNS, TAGS.CAMPAIGN],
    }),
  }),
})

export const {
  useGetCampaignQuery,
  useGetCampaignsQuery,
  useGetCampaignsForClientQuery,
  useAddCampaignMutation,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useAddProducerToCampaignMutation,
  useRemoveProducerFromCampaignMutation,
  useAddRepresentativeToCampaignMutation,
  useRemoveRepresentativeFromCampaignMutation,
  useAddSectionToLayoutMutation,
  useUpdateSectionInLayoutMutation,
  useDeleteSectionFromLayoutMutation,
  useAddFieldToSectionMutation,
  useUpdateFieldInSectionMutation,
  useDeleteFieldFromSectionMutation,
} = campaignsSlice

export default campaignsSlice
